<template>
  <div id="section_hero" class="relative w-screen h-screen">
    <HeroLogo/>

    <div id="hero_content" class="absolute flex items-center justify-center w-full h-full">
      <div class="ml-0 qhd:ml-8 fullhd:ml-64 w-full lg:w-auto flex-row absolute lg:relative">
        <div class="flex justify-center text-center ml-6 mr-6 lg:ml-0 lg:mr-0 ">
          <h1 class="font-display text-6xl text-white">Coding Your Future</h1>
        </div>
        <div id="view_more" class="flex justify-center mt-32">
          <a href="#"
             class="block w-40 h-10 pr-9 pl-10 pt-2 pb-5 font-display border-yellow-primary bg-yellow-primary rounded-full">
            View more
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HeroLogo from './HeroLogo.vue';

  import '../../assets/css/index/hero.css';

  export default {
    name: 'SectionHero',
    components: {
      HeroLogo
    }
  }
</script>
